<div class="preheader" *ngIf="showPreheader" [hidden]="hidePreheader">
    <a *ngIf="showPcUpsell" class="pc-upsell-message heading-5" data-testid="cart.preheader.pc.upsell.title"
       (click)="sendUpsellPromotionClick()"
       [routerLink]="ENROLL_PC_INFO_ROUTE">{{pcUpsellTranslation}}</a>
    <a *ngIf="showAoUpsell" class="ao-upsell-message heading-5" data-testid="cart.preheader.ao.upsell.title"
       (click)="sendUpsellPromotionClick()"
       [routerLink]="(this.canEditAutoOrderOnline || this.canAddAutoOrderOnline) ? [AUTO_ORDER_MANAGE_ROUTE] : null"
       translate="cart.preheader.ao.upsell.title"></a>
    <button type="button" class="close fa-solid fa-xmark" [attr.aria-label]="'cart.button.close'| translate" (click)="closePreheader()">
    </button>
</div>
